import { Box, Center, Text } from "native-base";
import React from "react";
import { FlatList } from "react-native";

import Breadcrumb from "@/components/atoms/Breadcrumb";
import Container from "@/components/organisms/Container";
import ProductSectionList from "@/components/organisms/ProductSectionList";
import ProductSectionListLoading from "@/components/organisms/ProductSectionList/ProductSectionListLoading";
import WebHeader from "@/components/organisms/WebHeader";
import { useStoreById } from "@/hooks/domain/stores";

import { HallCategoryListScreenProps } from "./types";

const HallCategoryListWeb = ({
  categoryList,
  hall,
  hallList,
  isLoading,
  onSelectProduct,
  onGoBack,
  onSelectHall,
  onPressViewMore,
}: HallCategoryListScreenProps) => {
  const { data: store } = useStoreById(hall?.estabelecimento, {
    enabled: !!hall?.estabelecimento,
  });
  return (
    <Container
      px="5%"
      Header={
        <WebHeader
          title={store?.nome_fantasia}
          searchInStoreId={store?._id}
          badgeTitle="Corredores"
          badgeList={hallList}
          activeBadgeId={hall?._id}
          onPressBack={onGoBack}
          onSelectBadge={(item) => onSelectHall(item?._id)}
        />
      }>
      <Box pt="4">
        <Breadcrumb
          routes={[
            { title: "Home", routeName: "home" },
            {
              title: store?.nome_fantasia,
              routeName: "storeHome",
              params: { storeId: store?._id },
            },
            { title: hall?.nome, routeName: "storeHallList" },
          ]}
        />
      </Box>
      <Center py="8">
        <Text fontSize="3xl" color="text.600" bold>
          {hall?.nome}
        </Text>
      </Center>
      {isLoading && <ProductSectionListLoading />}
      {!!categoryList?.length && (
        <FlatList
          data={categoryList}
          renderItem={({ item: category }) => (
            <ProductSectionList
              title={category.nome}
              data={category.produtos}
              isLoading={isLoading}
              onSelect={onSelectProduct}
              onPressViewMore={() => onPressViewMore(category?._id)}
            />
          )}
        />
      )}
    </Container>
  );
};

export default HallCategoryListWeb;
